<template>
  <v-card class="mx-auto home-news" elevation="5">
    <v-card-title>
      <span class="title home-news-title">{{ title }}</span>
    </v-card-title>

    <v-card-text class="body-1 home-news-text">
      <slot />
    </v-card-text>

    <v-card-actions>
      <v-list-item class="grow">
        <v-row align="center" justify="end">
          <span class="subheading">{{ formattedDate }}</span>
        </v-row>
      </v-list-item>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.home-news {
  margin-bottom: 20px;
  max-width: 800px;
}

.home-news-text {
  text-align: left;
}
</style>

<script>
import moment from "moment";

export default {
  name: "entry",
  props: {
    title: String,
    date: String
  },
  data() {
    return {
      formattedDate: moment(this.date).format("LLLL")
    };
  }
};
</script>
